import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getPageMenuLocal } from '@/api/setting/setting';
import i18n from 'i18next';

// 定义支持的语言
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'zh', name: '中文' },
  // 可以添加更多语言
];

// 模拟API调用获取翻译的函数
const fetchTranslations = async (lang: string) => {
  // 模拟API延迟
  return new Promise((resolve) => {
    getPageMenuLocal({ langCode: lang }).then((res) => {
      console.log(res);
      resolve(res.pageMenuLocal);
    });
  });
};

// 动态加载语言包的函数
const loadLanguageAsync = async (lang: string) => {
  // 如果已经加载过该语言，直接切换
  if (i18n.hasResourceBundle(lang, 'translation')) {
    await i18n.changeLanguage(lang);
    return;
  }

  try {
    // 模拟API调用，实际项目中替换为真实API
    const translations = await fetchTranslations(lang);
    
    // 添加语言资源
    i18n.addResourceBundle(lang, 'translation', translations);
    // 切换语言
    await i18n.changeLanguage(lang);
  } catch (error) {
    console.error(`Failed to load ${lang} translations:`, error);
    // 加载失败时回退到默认语言
    await i18n.changeLanguage('en');
  }
};

/**
 * 自定义Hook，用于管理国际化功能
 */
export const useI18n = () => {
  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');
  const [isLoading, setIsLoading] = useState(false);

  // 初始化时从本地存储加载上次使用的语言
  useEffect(() => {
    // const savedLanguage = localStorage.getItem('language');
    // if (savedLanguage && savedLanguage !== currentLanguage) {
    //   changeLanguage(savedLanguage);
    // }
  }, []);

  // 语言切换函数
  const changeLanguage = useCallback(async (lang: string) => {
    if (lang === currentLanguage) return;
    
    try {
      setIsLoading(true);
      await loadLanguageAsync(lang);
      setCurrentLanguage(lang);
      // 保存语言选择到本地存储
      localStorage.setItem('language', lang);
    } catch (error) {
      console.error('Failed to change language:', error);
    } finally {
      setIsLoading(false);
    }
  }, [currentLanguage]);

  return {
    t,                      // 翻译函数
    currentLanguage,        // 当前语言
    changeLanguage,         // 切换语言的函数
    isLoading,              // 加载状态
    supportedLanguages: SUPPORTED_LANGUAGES  // 支持的语言列表
  };
};

export default useI18n; 